
document.addEventListener('DOMContentLoaded', function () {
  initializeStorySections(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initializeStorySections(event.target);
  
});

function initializeStorySections(scope) {
  const blogSections = scope.querySelectorAll
    ? scope.querySelectorAll('.blog-section-wrap')
    : [];

  blogSections.forEach((blogSection) => {
    if (blogSection.dataset.storiesInitialized === 'true') {
      return;
    }

    blogSection.dataset.storiesInitialized = 'true';

    const titleItems = Array.from(
      blogSection.querySelectorAll('.blog-title-item[data-url]')
    );

    const filterButtons = Array.from(
      blogSection.querySelectorAll('.filter-btn')
    );

    const filterContainer = blogSection.querySelector(
      '.blog-dynamic-filter'
    );

    const contentTarget = blogSection.querySelector(
      '[id^="blogContentTarget-"]'
    );

    const navigation = blogSection.querySelector(
      '[data-blog-navigation]'
    );

    if (!titleItems.length || !contentTarget) {
      return;
    }

    const previousButton = navigation?.querySelector(
      '[data-blog-previous]'
    );

    const nextButton = navigation?.querySelector(
      '[data-blog-next]'
    );

    const previousTitle = navigation?.querySelector(
      '[data-previous-title]'
    );

    const nextTitle = navigation?.querySelector(
      '[data-next-title]'
    );

    function isMobile() {
      return window.innerWidth < 768;
    }

    function getArticleTitle(articleItem) {
      const titleElement = articleItem.querySelector(
        '.blog-title-text'
      );

      return titleElement?.textContent?.trim() || '';
    }

    function getVisibleArticleItems() {
      return titleItems.filter(
        (item) => !item.classList.contains('is-hidden')
      );
    }

    function scrollToContentTop() {
      requestAnimationFrame(() => {
        contentTarget.scrollTo({
          top: 0,
          behavior: 'smooth'
        });

        contentTarget.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    }

    function hideMobileContent() {
      contentTarget.classList.remove(
        'has-content-loaded',
        'is-loading'
      );
    }

    function updateNavigation() {
      if (
        !navigation ||
        !previousButton ||
        !nextButton ||
        !previousTitle ||
        !nextTitle
      ) {
        return;
      }

      const visibleItems = getVisibleArticleItems();

      const activeIndex = visibleItems.findIndex((item) =>
        item.classList.contains('is-active')
      );

      if (activeIndex === -1) {
        previousButton.hidden = true;
        nextButton.hidden = true;
        previousTitle.textContent = '';
        nextTitle.textContent = '';
        return;
      }

      const previousArticle =
        activeIndex > 0
          ? visibleItems[activeIndex - 1]
          : null;

      const nextArticle =
        activeIndex < visibleItems.length - 1
          ? visibleItems[activeIndex + 1]
          : null;

      if (previousArticle) {
        previousTitle.textContent =
          getArticleTitle(previousArticle);

        previousButton.hidden = false;
        previousButton.dataset.articleUrl =
          previousArticle.dataset.url || '';
      } else {
        previousTitle.textContent = '';
        previousButton.hidden = true;
        delete previousButton.dataset.articleUrl;
      }

      if (nextArticle) {
        nextTitle.textContent =
          getArticleTitle(nextArticle);

        nextButton.hidden = false;
        nextButton.dataset.articleUrl =
          nextArticle.dataset.url || '';
      } else {
        nextTitle.textContent = '';
        nextButton.hidden = true;
        delete nextButton.dataset.articleUrl;
      }
    }

    function restoreNavigation() {
      if (!navigation) {
        return;
      }

      if (!contentTarget.contains(navigation)) {
        contentTarget.appendChild(navigation);
      }
    }

    function loadArticle(
      articleItem,
      {
        scrollToContent = false,
        forceLoad = false
      } = {}
    ) {
      if (!articleItem) {
        return;
      }

      const articleUrl = articleItem.getAttribute('data-url');

      if (!articleUrl) {
        return;
      }

      const isAlreadyActive =
        articleItem.classList.contains('is-active');

      if (isAlreadyActive && !forceLoad) {
        return;
      }

      titleItems.forEach((item) => {
        item.classList.remove('is-active');
      });

      articleItem.classList.add('is-active');
      articleItem.classList.add('has-been-clicked');

      contentTarget.classList.add(
        'has-content-loaded',
        'is-loading'
      );

      updateNavigation();

      const separator = articleUrl.includes('?') ? '&' : '?';
      const fetchUrl = `${articleUrl}${separator}view=ajax`;

      fetch(fetchUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              `Article request failed: ${response.status}`
            );
          }

          return response.text();
        })
        .then((html) => {
          contentTarget.innerHTML = html;

          restoreNavigation();
          updateNavigation();

          contentTarget.classList.remove('is-loading');

          if (scrollToContent || isMobile()) {
            scrollToContentTop();
          }
        })
        .catch((error) => {
          console.error(
            'Error fetching blog content:',
            error
          );

          contentTarget.innerHTML =
            '<p>Error loading article. Please try again.</p>';

          restoreNavigation();
          updateNavigation();

          contentTarget.classList.remove('is-loading');
        });

        
    }

function applyStoryFilter(
  filterValue,
  loadFirstArticle = false
) {
  const normalizedFilter = (
    filterValue || ''
  )
    .toLowerCase()
    .trim();

  titleItems.forEach((item) => {
    const itemCategory = (
      item.getAttribute('data-category') || ''
    )
      .toLowerCase()
      .trim();

    const matchesFilter =
      itemCategory.includes(normalizedFilter);

    item.classList.toggle(
      'is-hidden',
      !matchesFilter
    );

    item.classList.remove('is-active');
  });

  const visibleItems = getVisibleArticleItems();

  let emptyMessage = blogSection.querySelector(
    '[data-blog-empty-message]'
  );

  if (!visibleItems.length) {
    /*
     * Create the empty message once and place it
     * below the sidebar article list.
     */
    if (!emptyMessage) {
      emptyMessage = document.createElement('div');
      emptyMessage.className = 'blog-empty-filter-message';
      emptyMessage.setAttribute(
        'data-blog-empty-message',
        ''
      );

      emptyMessage.innerHTML = `
        <p>No posts found in this category.</p>
      `;

      const titlesList = blogSection.querySelector(
        '.blog-titles-list'
      );

      if (titlesList) {
        titlesList.insertAdjacentElement(
          'afterend',
          emptyMessage
        );
      }
    }

    emptyMessage.hidden = false;

    /*
     * Hide the mobile article content panel.
     */
    hideMobileContent();

    /*
     * Hide Previous and Next navigation.
     */
    updateNavigation();

    return;
  }

  /*
   * Hide the empty message when posts exist.
   */
  if (emptyMessage) {
    emptyMessage.hidden = true;
  }

  const firstVisibleArticle = visibleItems[0];

  /*
   * Desktop:
   * Select and load the first matching article.
   *
   * Mobile:
   * Show only the sidebar results and wait
   * for the user to select an article.
   */
  if (loadFirstArticle) {
    firstVisibleArticle.classList.add('is-active');

    updateNavigation();

    loadArticle(firstVisibleArticle, {
      scrollToContent: false,
      forceLoad: true
    });
  } else {
    updateNavigation();
  }
}

    /*
     * Initial Chapters filter.
     *
     * Desktop keeps the initially rendered article selected.
     * Mobile shows only the filtered sidebar list.
     */
    if (isMobile()) {
      applyStoryFilter('chapters', false);
      hideMobileContent();
    } else {
      applyStoryFilter('chapters', false);

      const firstVisibleArticle =
        getVisibleArticleItems()[0];

      if (firstVisibleArticle) {
        firstVisibleArticle.classList.add('is-active');
      }

      updateNavigation();
    }

    filterButtons.forEach((button) => {
      button.addEventListener('click', function () {
        filterButtons.forEach((item) => {
          item.classList.remove('is-active');
        });

        this.classList.add('is-active');

        const filterValue = (
          this.getAttribute('data-filter') || ''
        )
          .toLowerCase()
          .trim();

        if (isMobile()) {
          /*
           * Mobile:
           * Filter the sidebar only.
           * Do not open or load article content.
           */
          applyStoryFilter(filterValue, false);
          hideMobileContent();

          if (filterContainer) {
            filterContainer.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        } else {
          /*
           * Desktop:
           * Filter and load the first matching article.
           */
          applyStoryFilter(filterValue, true);
        }
      });
    });

    titleItems.forEach((item) => {
      item.addEventListener('click', function () {
        if (this.classList.contains('is-hidden')) {
          return;
        }

        const alreadyActive =
          this.classList.contains('is-active');

        /*
         * On desktop, do not reload the current article.
         * On mobile, allow article clicks to open the panel.
         */
        if (alreadyActive && !isMobile()) {
          return;
        }

        loadArticle(this, {
          scrollToContent: isMobile(),
          forceLoad: true
        });
      });
    });

    previousButton?.addEventListener(
      'click',
      function () {
        const articleUrl = this.dataset.articleUrl;

        const previousArticle = titleItems.find(
          (item) => item.dataset.url === articleUrl
        );

        loadArticle(previousArticle, {
          scrollToContent: true,
          forceLoad: true
        });
      }
    );

    nextButton?.addEventListener(
      'click',
      function () {
        const articleUrl = this.dataset.articleUrl;

        const nextArticle = titleItems.find(
          (item) => item.dataset.url === articleUrl
        );

        loadArticle(nextArticle, {
          scrollToContent: true,
          forceLoad: true
        });
      }
    );

    blogSection.addEventListener(
      'click',
      function (event) {
        const backButton = event.target.closest(
          '#backtostories'
        );

        if (!backButton) {
          return;
        }

        event.preventDefault();

        hideMobileContent();

        if (isMobile() && filterContainer) {
          filterContainer.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    );
  });
}